import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { get } from '@partsbadger/utils';
import { EnhancedViewer as Viewer } from '@partsbadger/threedviewer';

export const ThreeDViewerFromStepFile = observer(({ id }: { id: number }) => {
    const [url, setUrl] = useState<string | undefined>();

    useEffect(() => {
        get(`/customer/step-files/${id}/threed-signed-url/`).then(data => {
            setUrl(data.url);
        });
    }, [id]);

    if (url) {
        return <Viewer url={url} />;
    }
    return <div />;
});
